import { AfterViewInit, Component, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import SwiperCore, { Autoplay, Keyboard, Lazy, Pagination, SwiperOptions, Virtual, Zoom } from 'swiper';

SwiperCore.use([Autoplay, Keyboard, Pagination, Virtual, Zoom, Lazy]);
@Component({
  selector: 'app-image-modal',
  templateUrl: './image-modal.page.html',
  styleUrls: ['./image-modal.page.scss'],
})
export class ImageModalPage {
  constructor(
    private modalController: ModalController
  ) { }


  @Input() img: any;
  sliderOpts: SwiperOptions = {
    centeredSlides: true,
    lazy: true,
    preloadImages: false,
    zoom: {
      maxRatio: 3,
    }
  };
  myzoom: any;

  public swiperInit(swiper: any) {
    this.myzoom = swiper.zoom;
  }

  zoom(zoomIn: boolean) {
    if (zoomIn) {
      this.myzoom.in();
    } else {
      this.myzoom.out();
    }
  }

  close() {
    this.modalController.dismiss();
  }
}
